import { render, staticRenderFns } from "./claims-detail.vue?vue&type=template&id=dda01a64&scoped=true&"
import script from "./claims-detail.vue?vue&type=script&lang=ts&"
export * from "./claims-detail.vue?vue&type=script&lang=ts&"
import style0 from "./claims-detail.vue?vue&type=style&index=0&id=dda01a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda01a64",
  null
  
)

export default component.exports